import type { ModalActionHandler } from './modalActionTypes';
import { unassignJob } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const fireMinterAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.jobs.minters <= 0) return false;
    if (!unassignJob(settlement, 'minters')) return false;
    settlement.production.mint.progress.pop();
    return true;
};
